document.addEventListener('DOMContentLoaded', function() {

    let zoneDomains = [
        'zone.ee',
        'zone.eu',
        'zone.fi',
        'myzone.app',
    ];
    
    const queryParams = [
        'utm_source',
        'utm_medium', 
        'adgroup', 
        'creative', 
        'keyword', 
        'match', 
        'device', 
        'gclid',
    ];

    let excludeUrl = [
        '#',
        'mailto',
    ];

    const domainFormTargets = [
        'data-target',
        'data-target-url',
    ]

    if (typeof utmZoneDomains !== 'undefined') {
        if (utmZoneDomains && utmZoneDomains.length) {
            zoneDomains = utmZoneDomains;
        }
    }

    if (typeof utmZoneExcludeUrl !== 'undefined') {
        if (utmZoneExcludeUrl && utmZoneExcludeUrl.length) {
            excludeUrl = utmZoneExcludeUrl;
        }
    }

    let existedQueryParams = [];

    queryParams.forEach(param => {
        
        let existingParam = getQueryParam(param);

        if(existingParam !== null) {
            existedQueryParams.push(param + '=' + existingParam);
        }

    });

    let links = document.querySelectorAll('a'); 
    let domainForms = document.querySelectorAll('form[data-target], form[data-target-url]');
    
    domainForms.forEach(form => {

        domainFormTargets.forEach(target => {
            targetUrl = form.getAttribute(target);
            if(targetUrl) {
                form.setAttribute(target, handleUrl(targetUrl));
            }
        })

    });

    links.forEach(link => {
        
        zoneDomains.forEach(domain => {
           
            if(link.href.includes(domain) && !excludeUrl.some(v => link.href.includes(v))) {
                link.href = handleUrl(link.href);
            } 

            if(link.href.includes(domain) && link.href.includes('#/?')) {
                link.href = handleHashUrl(link.href);
            }

        })

    });
    
    function handleUrl(urlToHandle) {

        if(existedQueryParams.length > 0) {
            urlToHandle = (urlToHandle.indexOf('?') === -1) ? urlToHandle + '?' : urlToHandle + '&';
            return urlToHandle + existedQueryParams.join('&');
        } else {
            return urlToHandle;
        }
       
    }

    function handleHashUrl(urlToHandle) {

        if(existedQueryParams.length > 0) {
            let splitted = urlToHandle.split('#');
            urlToHandle = splitted[0] + '?';
            return urlToHandle + existedQueryParams.join('&') + '#' + splitted[1];
        } else {
            return urlToHandle;
        }
       
    }
    
    function getQueryParam(name) {
        if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(window.location.search)) {
            return decodeURIComponent(name[1]);
        } else {
            return null;
        }
            
    }

});


